import { TWasmId } from "~/interfaces";
import Wasm from "../wasm";
import { IWasmStoreMarker } from "../store/interfaces";
import { loadImage } from "./utils";

export default class WasmMapMarker {
	_wasmIds: Array<TWasmId>;

	_wasm: Wasm;

	_data: IWasmStoreMarker;

	_customData: any;

	constructor(wasm: Wasm, data: IWasmStoreMarker) {
		this._wasmIds = [];
		this._wasm = wasm;
		this._data = structuredClone(data);
		this._customData = {
			url: this._data.img,
			...data.customData,
		};

		this._build();
		this._setVisibility();
	}

	_destroy(wasmIds: Array<TWasmId>) {
		const { mapContent } = this._wasm.exports;

		for (const wasmId of wasmIds) {
			mapContent.remove(wasmId);
		}
	}

	destroy() {
		this._destroy(this._wasmIds);
	}

	setPosition(wgsLon: number, wgsLat: number) {
		const { mapContent, module } = this._wasm.exports;
		const mercPos = module.GeoMath.wgsToMercator({
			x: wgsLon,
			y: wgsLat,
		});

		this._data.lon = wgsLon;
		this._data.lat = wgsLat;

		for (const wasmId of this._wasmIds) {
			mapContent.setPointPosMerc(wasmId, mercPos.x, mercPos.y);
		}
	}

	setActive(active: boolean) {
		this._data.active = active;

		this._setVisibility();
	}

	async setIcon(url: string) {
		try {
			await loadImage(url);

			const curWasmIds = this._wasmIds.slice();

			this._data.img = url;
			this._customData.url = url;
			this._build();

			// opozdime
			setTimeout(() => {
				this._destroy(curWasmIds);
			}, 100);
		} catch (exc) {
			//
		}
	}

	get wasmIds() {
		return this._wasmIds;
	}

	_build() {
		const { mapContent, module } = this._wasm.exports;
		let texture = this._wasm.exports.icons.dropBigRedWithIcon;

		switch (this._data.type) {
			case "standard":
				texture = this._wasm.exports.icons.dropBigRedWithIcon;
				break;

			case "custom":
				texture = this._wasm.exports.icons.custom;
				break;

			case "custom2":
				texture = this._wasm.exports.icons.custom2;
				break;

			default:
		}

		const mainMarker = mapContent.addPoint(this._data.lon, this._data.lat, texture, 0, module.RequestedCallbacks.OnClickAndHover, this._customData);
		const secondMarker = mapContent.addPoint(this._data.lon, this._data.lat, this._wasm.exports.icons.dropBigGrayWithIcon, 0, module.RequestedCallbacks.OnClickAndHover, this._customData);

		this._wasmIds.push(mainMarker);
		this._wasmIds.push(secondMarker);
	}

	_setVisibility() {
		const { mapContent } = this._wasm.exports;
		const firstId = this._wasmIds[0];
		const secondId = this._wasmIds[1];

		mapContent.setIsVisible([firstId], this._data.active);
		mapContent.setIsVisible([secondId], !this._data.active);
	}
}
